import React from 'react';
import Model from '../models/LuciferMorningstar';

const Player = () => {
  return (
    <group position={[0, 0.06, 0]}>
      {/* Increased scale for prominence */}
      <Model scale={[1.4, 1.4, 1.4]} castShadow receiveShadow />
    </group>
  );
};

export default Player;
